<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список адресов</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактировать адрес</li>
        </ol>
    </nav>

    <div class="col-md-4 col-12">
        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-region_id">Регион</label>
                <select :disabled="isNeofarm" id="client-region_id" v-model="region_id" class="form-select">
                    <option disabled value="0">-------</option>
                    <option v-for="item in regions" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-city_id">Город</label>
                <select @change="onChangeRegionId()" :disabled="isNeofarm" id="client-city_id" v-model="city_id" class="form-select">
                    <option disabled value="0">-------</option>
                    <option v-for="item in cities" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-repository_id">Репозиторий</label>
                <select :disabled="isNeofarm" id="client-repository_id" v-model="repository_id" class="form-select">
                    <option disabled value="0">-------</option>
                    <option v-for="repository in repositories" :value="repository.id">{{ repository.repository_path }}</option>
                </select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-number">Номер</label>
                <input :disabled="isNeofarm" type="text" class="form-control" id="client-number" v-model="number" placeholder="Введите номер">
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-street">Адрес</label>
                <input :disabled="isNeofarm" type="text" class="form-control" id="client-street" v-model="street" placeholder="Введите адрес">
            </div>
        </div>


        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-house">Номер дома</label>
                <input :disabled="isNeofarm" type="text" class="form-control" id="client-house" v-model="house" placeholder="Введите номер дома">
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-floor">Этаж</label>
                <input :disabled="isNeofarm" type="text" class="form-control" id="client-floor" v-model="floor" placeholder="Введите этаж">
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label for="client-comment">Комментарий</label>
                <input :disabled="isNeofarm" type="text" class="form-control" id="client-comment" v-model="comment" placeholder="Введите комментарий">
            </div>
        </div>
    </div>

    <div class="d-flex w-50 align-items-center justify-content-start">
        <button :disabled="isNeofarm" class="btn btn-lg btn-primary me-3" v-on:click="updateAddress()">
            Изменить
        </button>

        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>
</template>

<script>
import Address from "../../../../models/Address";

export default {
    name: "AddressEditComponent",
    props: {
        route_back: String,
        route_region_search: String,
        route_city_search: String,
        route_repository_search: String,
        route_update: String,
        route_get: String,
        item_id: {
            type: [Number, String],
            default: 0
        }
    },
    watch: {
        region_id: function (id) {
            console.log(id)
        }
    },
    data: function () {
        return {
            address: new Address({
                route_update: this.route_update,
                route_get: this.route_get,
                route_region_search: this.route_region_search,
                route_city_search: this.route_city_search,
                route_repository_search: this.route_repository_search,
            }),
            item: {},
            regions: [],
            cities: [],
            repositories: [],
            region_id: 0,
            city_id: 0,
            metro_id: 0,
            repository_id: 0,
            number: '',
            worktime_id: 0,
            street: '',
            house: 0,
            floor: 0,
            comment: '',
            isNeofarm: false
        }
    },
    methods: {
        itemGet: async function () {
            this.item = await this.address.get(this.item_id);
            
            if (this.item.client_id == 1) {
                this.isNeofarm = true;
            }

            this.region_id = this.item.region_id;
            this.city_id = this.item.city_id;
            this.repository_id = this.item.repository_id;
            this.number = this.item.number;
            this.street = this.item.address;
            this.house = this.item.house;
            this.floor = this.item.floor;
            this.comment = this.item.comment;
        },
        updateAddress: async function () {
            let result = await this.address.update({
                region_id: this.region_id,
                city_id: this.city_id,
                metro_id: this.metro_id,
                repository_id: this.repository_id,
                number: this.number,
                worktime_id: this.worktime_id,
                address: this.street,
                house: this.house,
                floor: this.floor,
                comment: this.comment
            }, this.item_id);
            if (result) {
                window.location.href = this.route_back;
            } else {
                console.log('error: update_address');
            }
        },
        searchRegions: async function() {
            let regions = await this.address.regions();
            this.regions = regions.items;
        },
        searchCities: async function() {
            let cities = await this.address.cities();
            this.cities = cities.items;
        },
        searchRepositories: async function() {
            let repositories = await this.address.repositories();
            this.repositories = repositories.items;
        },
        onChangeRegionId: async function () {
            const data = await axios.get(this.route_city_search, {
                params: {
                    page: 1,
                    limit: 1000,
                    region_id: this.formData.region_id
                }
            }).then(response => {
                return response.data
            });

            this.cities = data.status == "ok" ? data.items : [];
        }
    },
    mounted() {
        this.itemGet();
        this.searchRegions();
        this.searchCities();
        this.searchRepositories();
    }
}
</script>

<style scoped>

</style>
